import React from 'react';
import { PROPERTY_IMAGES_URL, AGENCY_LOGOS_URL } from "../../../../constants/url";

const TemplateMinimal = ({ property, images, currentagency }) => {
  const imagesArr = images?.slice(0, 5).map((img) => `${PROPERTY_IMAGES_URL}${img.propertyimages}`) || [];
  
  const formatPrice = (num) => {
    if (num >= 10000000) return `${(num / 10000000).toFixed(2)} Cr`;
    if (num >= 100000) return `${(num / 100000).toFixed(2)} Lk`;
    return num?.toLocaleString() || "0";
  };

  return (
    <div style={{ width: '1080px', height: '1920px', backgroundColor: 'white', position: 'relative', overflow: 'hidden', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', fontFamily: 'sans-serif' }}>
      {/* Top Main Image Area */}
      <div style={{ height: '1000px', position: 'relative', padding: '40px' }}>
        <div style={{ width: '100%', height: '100%', borderRadius: '60px', overflow: 'hidden', boxShadow: '0 20px 50px rgba(0,0,0,0.15)', position: 'relative' }}>
          <img 
            src={imagesArr[0]} 
            crossOrigin="anonymous"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            alt="main"
          />
          <div style={{ position: 'absolute', top: '40px', right: '40px', backgroundColor: 'rgba(255,255,255,0.9)', backdropFilter: 'blur(8px)', padding: '15px 40px', borderRadius: '50px', boxShadow: '0 10px 20px rgba(0,0,0,0.1)' }}>
            <p style={{ color: '#56C662', fontWeight: 'bold', fontSize: '24px', textTransform: 'uppercase', margin: 0 }}>
              {property?.PropertyPurpose === 'Buy' ? 'For Sale' : 'For Rent'}
            </p>
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div style={{ flexGrow: 1, padding: '0 60px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '40px' }}>
          <div style={{ maxWidth: '70%' }}>
            <h1 style={{ fontSize: '72px', fontWeight: 900, color: '#1a1a1a', lineHeight: 1.1, marginBottom: '20px', margin: 0 }}>
              {property?.propertytitle || "Modern Living Space"}
            </h1>
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', fontSize: '32px', color: '#666' }}>
              <span style={{ fontSize: '40px', color: '#56C662' }}>📍</span>
              <span>{property?.SubLocation}, {property?.ProvinceName}</span>
            </div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <p style={{ fontSize: '24px', color: '#999', textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '10px', margin: 0 }}>Price</p>
            <p style={{ fontSize: '64px', fontWeight: 900, color: '#56C662', margin: 0 }}>Rs {formatPrice(property?.propertyprice)}</p>
          </div>
        </div>

        {/* Minimal Divider */}
        <div style={{ height: '2px', backgroundColor: '#f0f0f0', width: '100%', marginBottom: '40px' }} />

        {/* Specs */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '60px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <div style={{ width: '80px', height: '80px', backgroundColor: '#f8f8f8', borderRadius: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '40px' }}>
              🛏️
            </div>
            <div>
              <p style={{ fontSize: '40px', fontWeight: 'bold', margin: 0 }}>{property?.bedrooms || 0}</p>
              <p style={{ fontSize: '20px', color: '#999', textTransform: 'uppercase', fontWeight: 'bold', margin: 0 }}>Beds</p>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <div style={{ width: '80px', height: '80px', backgroundColor: '#f8f8f8', borderRadius: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '40px' }}>
              🚿
            </div>
            <div>
              <p style={{ fontSize: '40px', fontWeight: 'bold', margin: 0 }}>{property?.bathrooms || 0}</p>
              <p style={{ fontSize: '20px', color: '#999', textTransform: 'uppercase', fontWeight: 'bold', margin: 0 }}>Baths</p>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <div style={{ width: '80px', height: '80px', backgroundColor: '#f8f8f8', borderRadius: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '40px' }}>
              📏
            </div>
            <div>
              <p style={{ fontSize: '40px', fontWeight: 'bold', margin: 0 }}>{Math.floor(property?.propertysizesqft || 0)}</p>
              <p style={{ fontSize: '20px', color: '#999', textTransform: 'uppercase', fontWeight: 'bold', margin: 0 }}>Sqft</p>
            </div>
          </div>
        </div>

        {/* Agency Info */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '40px', backgroundColor: '#f8f8f8', borderRadius: '60px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
            {currentagency?.agencylogo ? (
              <img 
                src={`${AGENCY_LOGOS_URL}${currentagency.agencylogo}`}
                crossOrigin="anonymous"
                style={{ height: '100px', width: '100px', objectFit: 'contain', borderRadius: '20px', backgroundColor: 'white', padding: '10px' }}
                alt="agency"
              />
            ) : (
              <div style={{ width: '100px', height: '100px', backgroundColor: '#56C662', borderRadius: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '48px', fontWeight: 900 }}>
                {currentagency?.agencyname?.charAt(0) || 'P'}
              </div>
            )}
            <div>
              <p style={{ fontSize: '32px', fontWeight: 900, color: '#1a1a1a', margin: 0 }}>{currentagency?.agencyname || 'Propertians'}</p>
              <p style={{ fontSize: '24px', color: '#666', margin: 0 }}>{currentagency?.mobileno || 'Contact Agent'}</p>
            </div>
          </div>
          <div style={{ backgroundColor: '#1a1a1a', color: 'white', padding: '25px 60px', borderRadius: '30px', fontSize: '24px', fontWeight: 'bold' }}>
            Book Visit
          </div>
        </div>
      </div>

      <div style={{ padding: '40px', textAlign: 'center' }}>
        <p style={{ color: '#ccc', fontSize: '24px', fontWeight: 700, letterSpacing: '8px', textTransform: 'uppercase', margin: 0 }}>propertians.com</p>
      </div>

      <div style={{ display: 'none' }}>
        {imagesArr.map((url, i) => <img key={i} src={url} crossOrigin="anonymous" alt="p" />)}
        {currentagency?.agencylogo && <img src={`${AGENCY_LOGOS_URL}${currentagency.agencylogo}`} crossOrigin="anonymous" alt="l" />}
      </div>
    </div>
  );
};

export default TemplateMinimal;
